// extracted by mini-css-extract-plugin
module.exports = {"main-layout":"index-main-layout-18vih"};